var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCouponsAndSavingMoney = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Shop-Sale-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Shop Sale 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.88a0.88 0.88 0 0 0 0.87 -0.88v-4.5a2.38 2.38 0 1 0 -4.75 0V19a0.88 0.88 0 1 0 1.75 0v-1.88a0.25 0.25 0 0 1 0.25 -0.24h0.75a0.25 0.25 0 0 1 0.25 0.24V19a0.88 0.88 0 0 0 0.88 0.88Zm-1.88 -4.76a0.25 0.25 0 0 1 -0.25 -0.24v-0.38a0.63 0.63 0 0 1 1.25 0v0.38a0.25 0.25 0 0 1 -0.25 0.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.87 14a0.12 0.12 0 0 1 0.13 -0.12h2a0.88 0.88 0 0 0 0 -1.76h-2A1.88 1.88 0 0 0 19.12 14v4A1.88 1.88 0 0 0 21 19.88h2a0.88 0.88 0 0 0 0 -1.76h-2a0.12 0.12 0 0 1 -0.13 -0.12v-0.88a0.25 0.25 0 0 1 0.25 -0.24H22a0.88 0.88 0 0 0 0 -1.76h-0.88a0.25 0.25 0 0 1 -0.25 -0.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.12a0.88 0.88 0 0 0 -0.88 0.88v5a1.88 1.88 0 0 0 1.88 1.88h2a0.88 0.88 0 0 0 0 -1.76h-2a0.12 0.12 0 0 1 -0.13 -0.12v-5a0.88 0.88 0 0 0 -0.87 -0.88Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37 17.7a2.19 2.19 0 0 0 -1 -1.82l-1.81 -1.22a0.43 0.43 0 0 1 0.24 -0.78h1.7a0.88 0.88 0 0 0 0 -1.76H2.8A2.19 2.19 0 0 0 0.62 14.3a2.21 2.21 0 0 0 1 1.82l1.84 1.22a0.43 0.43 0 0 1 -0.23 0.78H1.5a0.88 0.88 0 0 0 0 1.76h1.7a2.18 2.18 0 0 0 2.17 -2.18Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23a1 1 0 0 0 -1 -1h-17a1 1 0 0 0 0 2h17a1 1 0 0 0 1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 5.48a0.13 0.13 0 0 0 0 -0.06c-0.12 -0.42 -1.2 -4.33 -1.44 -5.24a0.26 0.26 0 0 0 -0.25 -0.18H13a0.25 0.25 0 0 0 -0.25 0.25v9.36a0.25 0.25 0 0 0 0.14 0.23 4.81 4.81 0 0 0 2.47 0.46 4.91 4.91 0 0 0 2.38 -0.85Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 5.07 22.24 1a1.51 1.51 0 0 0 -1.36 -1h-2.75a0.24 0.24 0 0 0 -0.19 0.1 0.25 0.25 0 0 0 -0.05 0.22l1.33 4.83a0.64 0.64 0 0 1 0 0.2v3.57a0.25 0.25 0 0 0 0.16 0.23 3.34 3.34 0 0 0 4.59 -3v-0.88a0.74 0.74 0 0 0 0.03 -0.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0.25A0.25 0.25 0 0 0 11 0H7.93a0.26 0.26 0 0 0 -0.24 0.18C7.45 1.09 6.37 5 6.26 5.42a0.13 0.13 0 0 0 0 0.06V9.3a0.24 0.24 0 0 0 0.11 0.21 4.94 4.94 0 0 0 2.29 0.79h0.4a4.68 4.68 0 0 0 2.06 -0.47 0.26 0.26 0 0 0 0.14 -0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.35a1.23 1.23 0 0 1 0 -0.2L6.1 0.32a0.24 0.24 0 0 0 0 -0.22 0.26 0.26 0 0 0 -0.2 -0.1H3.12a1.51 1.51 0 0 0 -1.36 1L0 5.07a0.79 0.79 0 0 0 0 0.2v0.91A3.24 3.24 0 0 0 2 9.1a3.31 3.31 0 0 0 2.6 0.05 0.25 0.25 0 0 0 0.16 -0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCouponsAndSavingMoney);
export default ForwardRef;